import FormSelect from "@mui/joy/Select";
import FormLabel from "@mui/joy/FormLabel";
import FormControl from "@mui/joy/FormControl";
import FormHelperText from "@mui/joy/FormHelperText";
import Option from "@mui/joy/Option";
import { Controller } from "react-hook-form";
import Tooltip from "@mui/joy/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { OptionObj } from "@/types/interfaces/common";
import IconButton from "@mui/joy/IconButton";
import CloseRounded from "@mui/icons-material/CloseRounded";

interface Props {
  name: string;
  label?: string;
  infoText?: string;
  control: any;
  items: OptionObj<string | number>[];
  error?: string;
  required?: boolean;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  showClear?: boolean;
  onValueChange?: (newValue: any) => void;
}

const Select = ({
  name,
  placeholder,
  label,
  infoText,
  disabled,
  control,
  error,
  required,
  items,
  showClear,
  onValueChange,
}: Props) => {
  return (
    <FormControl
      key={name}
      sx={{
        width: "100%",
      }}
      size="sm"
      error={!!error}
    >
      {label && (
        <FormLabel
          sx={{
            fontSize: "sm",
            fontWeight: "lg",
            mb: 1,
          }}
          required={required}
        >
          {infoText && (
            <Tooltip
              title={infoText}
              sx={{
                maxWidth: "250px",
              }}
              arrow
              placement="right"
            >
              <InfoOutlinedIcon
                sx={{
                  fontSize: 15,
                  mr: 0.5,
                }}
              />
            </Tooltip>
          )}
          {label}
        </FormLabel>
      )}
      {!label && infoText && (
        <Tooltip
          title={infoText}
          sx={{
            maxWidth: "250px",
          }}
          arrow
          placement="right"
        >
          <InfoOutlinedIcon
            sx={{
              fontSize: 15,
              mb: 1,
            }}
          />
        </Tooltip>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormSelect
            {...field}
            disabled={disabled}
            onChange={(_, newValue) => {
              field.onChange(newValue ?? "");
              onValueChange && onValueChange(newValue);
            }}
            {...(field.value &&
              showClear && {
                // display the button and remove select indicator
                // when user has selected a value
                endDecorator: (
                  <IconButton
                    // @ts-ignore
                    size="xs"
                    variant="plain"
                    color="neutral"
                    onMouseDown={(event) => {
                      // don't open the popup when clicking on this button
                      event.stopPropagation();
                    }}
                    onClick={() => {
                      field.onChange("");
                    }}
                  >
                    <CloseRounded />
                  </IconButton>
                ),
                indicator: null,
              })}
            placeholder={placeholder}
            sx={{
              py: 1.188,
            }}
          >
            {items.map((i) => (
              <Option key={i.value} value={i.value}>
                {i.label}
              </Option>
            ))}
          </FormSelect>
        )}
      />

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
export default Select;
